import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { TFundraiserState } from '@feathr/blackbox';
import type { IModalProps } from '@feathr/components';
import { Button, Icon, Modal, Well } from '@feathr/components';
import stripeS from '@feathr/extender/images/integrations/stripe_s.svg';

import ConnectState from '../ConnectState/ConnectState';

interface IProps extends IModalProps {
  stripeAccountId: string;
  state: TFundraiserState;
}

function StripeDetailsModal({
  stripeAccountId,
  onClose,
  state,
  ...modalProps
}: Readonly<IProps>): JSX.Element | null {
  const { t } = useTranslation();
  const {
    spacing: { '6': gap6 },
  } = useMantineTheme();

  if (!stripeAccountId) {
    return null;
  }

  return (
    <Modal
      onClose={onClose}
      title={t('Stripe account')}
      {...modalProps}
      rightActions={
        <>
          <Button onClick={onClose}>{t('Close')}</Button>
          <Button
            href={'https://dashboard.stripe.com/login'}
            suffix={<Icon icon={faExternalLink} />}
            target={'_blank'}
            type={'primary'}
          >
            {t('Manage account')}
          </Button>
        </>
      }
    >
      <Stack gap={gap6}>
        <Well
          description={stripeAccountId}
          label={t('Account ID')}
          prefix={
            <img alt={'Purple square with rounded corners. Inside is a white s.'} src={stripeS} />
          }
          theme={'white'}
        >
          <ConnectState state={state} />
        </Well>
      </Stack>
    </Modal>
  );
}

export default StripeDetailsModal;
